import { PureComponent } from "react";
import { List, Menu } from "semantic-ui-react";
import BlogItem from "../../components/blog-item";
import { v4 as uuidv4 } from 'uuid';
import getData from "../../data/blogs/blog";
import Layout from "../../layouts/layout/Layout";
import Blog from "../../components/blog/Blog";
import _ from "lodash";
import './Blog.css';

class Blogs extends PureComponent {
    constructor() {
        super();
        this.state = {
            datasource: []
        }
    }

    componentDidMount() {
        getData().then(data => {
            data = _.sortBy(data || [], item => item.name).reverse();
            data = _.filter(data, item => {
                const { name = "" } = item || {}
                return !_.isEqual(name, "static");
            });
            this.setState({
                datasource: data,
                activeItem: _.isEmpty(data) ? "" : data[0].name,
                data: _.isEmpty(data) ? "" : data[0],
            });
        })
    }

    handleItemClick = (e, { name }) => {
        const data = _.filter(this.state.datasource || [], (item) => item.name === name)
        this.setState({ activeItem: name, data: _.isEmpty(data) ? {} : data[0] })
    }

    render() {
        const { datasource, activeItem, data } = this.state;

        return <div className="Blog" >
            <Layout
                left={
                    <Menu fluid vertical tabular attached className="Menu">
                        {datasource.map(item =>
                            <BlogItem
                                key={uuidv4()}
                                name={item.name}
                                activeItem={activeItem}
                                onClick={this.handleItemClick}
                            />
                        )}
                    </Menu>
                }
                right={
                    <Blog data={data} />
                }
            >
            </Layout>
        </ div >
    }
}

export default Blogs;